import React, { FunctionComponent } from 'react'
import capitalize from 'lodash/capitalize'
import startCase from 'lodash/startCase'

import { RefiTransactionsCard } from './refiTransactionsCard'
import { RefiTransactionsRow } from './refiTransactionsRow'
import { displayDollars } from '../../helpers/displayFormatHelper'
import { utcToLocalDate } from '../../helpers/timeHelper'
import { RefiTransaction } from './types'

export interface Props {
  refiTransaction: RefiTransaction
}

export const RefiTransactionsCurrentLoan: FunctionComponent<Props> = ({
  refiTransaction,
}) => {
  if (refiTransaction && refiTransaction.currentLoan) {
    const { currentLoan } = refiTransaction
    const {
      balance,
      institution,
      apr,
      originationDate,
      payment,
      term,
      termRemaining,
    } = currentLoan

    return (
      <RefiTransactionsCard title="CURRENT LOAN">
        {institution && (
          <RefiTransactionsRow field="Institution" hasBottomBorder valuesBold>
            {startCase(capitalize(institution))}
          </RefiTransactionsRow>
        )}
        {apr && (
          <RefiTransactionsRow field="APR" valuesBold>
            {`${apr}%`}
          </RefiTransactionsRow>
        )}
        {currentLoan.amount && currentLoan.amount && (
          <RefiTransactionsRow field="Original amount" valuesBold>
            {displayDollars(currentLoan.amount)}
          </RefiTransactionsRow>
        )}
        {balance && (
          <RefiTransactionsRow field="Principal balance" valuesBold>
            {displayDollars(balance)}
          </RefiTransactionsRow>
        )}
        {payment && (
          <RefiTransactionsRow field="Monthly payment" valuesBold>
            {displayDollars(payment)}
          </RefiTransactionsRow>
        )}
        {originationDate && (
          <RefiTransactionsRow field="Origination date" valuesBold>
            {utcToLocalDate(originationDate)}
          </RefiTransactionsRow>
        )}
        {term && (
          <RefiTransactionsRow field="Original term" valuesBold>
            {`${term} months`}
          </RefiTransactionsRow>
        )}
        {termRemaining && (
          <RefiTransactionsRow field="Term remaining" valuesBold>
            {`${termRemaining} months`}
          </RefiTransactionsRow>
        )}
      </RefiTransactionsCard>
    )
  } else {
    return <RefiTransactionsCard title="CURRENT LOAN" />
  }
}

RefiTransactionsCurrentLoan.displayName = 'RefiTransactionsCurrentLoan'
